import React, { useState, useEffect } from 'react';
import Table from '../../../../../../components/Table/Table';
import Filters from '../../../../../../components/Filters/Filters';
import './SupportGroup.css';
import { useNavigate } from 'react-router-dom';
// Icons
import toggleActive from '../../../../../../assets/toggleActive.png';
import toggleInactive from '../../../../../../assets/toggleInactive.png';
import eyeOn from '../../../../../../assets/tokens/eyeOn.png';
// components
import Badge from '../../../../../../components/Badge/Badge';

const SupportGroup = ({ tickets }) => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [supportsData, setSupportsData] = useState([]);
  const [filteredSupportsData, setFilteredSupportsData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if(tickets && tickets.length > 0){
      setSupportsData(tickets);
      setTotalItems(tickets.length);
    }
    fetchColumns();
  }, [tickets]);

  useEffect(() => {
    let filteredData = [...supportsData];

    if (filters.status && filters.status.length > 0) {
      filteredData = filteredData.filter(ticket => filters.status.includes(ticket.status));
    }

    if (filters.dateOfRequest) {
      filteredData = filteredData.filter(ticket => {
        const ticketDate = new Date(ticket.created_at).toISOString().split('T')[0];
        const filterDate = new Date(filters.dateOfRequest).toISOString().split('T')[0];
        return ticketDate === filterDate;
      });
    }

    setFilteredSupportsData(filteredData);
  }, [filters, supportsData]);

  const fetchColumns = () => {
    const columns = [{
      header: 'Support Folio',
      field: 'id'
    }, {
      header: 'Who requested it?',
      field: 'user_name'
    }, {
      header: 'Reason',
      field: 'subject'
    }, {
      header: 'Date of request',
      field: 'created_at',
      render: (row) => {
        const date = new Date(row.created_at);
        return date.toLocaleDateString();
      }
    },
    { 
      header: 'Status',
      render: (row) => <Badge status={row.status} />
    }];

    columns.push({
      header: '',
      render: (row) => (
        <button className="action-btn" onClick={() => handleView(row)}>
          <img src={eyeOn} alt="view" />
        </button>
      )
    });

    setColumns(columns);
  };

  const handleView = (row) => {
    navigate(`/support/details/${row.id}`, {
      state: { 
        support: row,
        action: 'view'
      }
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // Fetch data for new page
  };

  return (
    <div className="supports-container">
      <div className="filters-section">
        <Filters
          onApplyFilters={setFilters}
          filters={[
            { 
              id: 'status',
              label: 'Status', 
              type: 'checkbox', 
              options: ['Active', 'Inactive'] 
            },
            { 
              id: 'dateOfRequest', 
              label: 'Date of request', 
              type: 'date',
              placeholder: 'Select date'
            }
          ]}
        />
      </div>

      <div className="table-section">
        <Table
          columns={columns}
          columnsShare={1}
          data={filteredSupportsData}
          totalItems={filteredSupportsData.length}
          currentPage={currentPage}
          itemsPerPage={10}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default SupportGroup;